module.exports = __webpack_public_path__ + "media/components/riskregister/icon-vectors/people-fa8b9ed1aa177f588760dd0bbab80a96.png";